var _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasicblockMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "243 92 514 816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 553,
    y: 243,
    width: 71,
    height: 71,
    fill: "#00a8e5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M473,394V243H394V606H624V394Zm80,141H473V465h80Z",
    fill: "#0f172a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 686,
    width: 230,
    height: 71,
    fill: "#0f172a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M314,92H243V908H757V92ZM686,837H314V163H686Z",
    fill: "#0f172a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicblockMark);
export default __webpack_public_path__ + "static/media/basicblock-mark.4e5d7693374243ebd61de408d5d79398.svg";
export { ForwardRef as ReactComponent };